import { render } from "./News_en.vue?vue&type=template&id=a858b08e"
import script from "./News_en.vue?vue&type=script&lang=js"
export * from "./News_en.vue?vue&type=script&lang=js"
script.render = render

export default script